import { useMemo } from 'react';

import { faCheck, faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { useTheme } from '@mui/material/styles';

type CheckboxVariant = 'complete' | 'incomplete';

interface TaskingCheckboxProps extends Omit<MuiCheckboxProps, 'color'> {
    variant?: CheckboxVariant;
    hideUncheckedIcon?: boolean;
}

// TODO: move to UI-components and reconcile with CheckboxGroupOptions
const TaskingCheckbox = ({
    variant = 'complete',
    hideUncheckedIcon = false,
    checked,
    onClick,
    ...props
}: TaskingCheckboxProps) => {
    const { palette, spacing } = useTheme();

    const { icon, mainColor, lightColor } = useMemo(() => {
        switch (variant) {
            case 'incomplete':
                return {
                    icon: faClose,
                    mainColor: palette.error.main,
                    lightColor: palette.error.light,
                };
            case 'complete':
            default:
                return {
                    icon: faCheck,
                    mainColor: palette.primary.main,
                    lightColor: palette.primary.light,
                };
        }
    }, [variant, palette]);

    const uncheckedIcon = hideUncheckedIcon ? (
        <span />
    ) : (
        <FontAwesomeIcon icon={icon} size="lg" color={mainColor} />
    );

    return (
        <MuiCheckbox
            {...props}
            checked={checked}
            onClick={onClick}
            icon={uncheckedIcon}
            checkedIcon={<FontAwesomeIcon icon={icon} size="lg" color={lightColor} />}
            sx={{
                minWidth: spacing(5),
                width: spacing(5),
                height: spacing(5),
                borderRadius: 3,
                backgroundColor: checked ? mainColor : palette.white.main,
                border: `1px solid ${mainColor}`,
                // TODO: This is needed to show the right background color on select but shouldn't be
                '&:hover': {
                    backgroundColor: checked ? mainColor : palette.white.main,
                },
                ...props.sx,
            }}
        />
    );
};

export default TaskingCheckbox;
